const { wrapPageElement } = require('./wrapPageElement')
exports.wrapPageElement = wrapPageElement
